import { LOCALES } from './../constants.js';

export default {
    [LOCALES.ENGLISH]: {
        'hello': 'Hello', 
        'generalInformation':'GENERAL INFORMATION',
        'technicalInformation':'TECHNICAL INFORMATION',
        'serviceType': 'SERVICE TYPE:',
        'encryption': 'Encryption :',
        'language':'Language :',
        'genre':'Genre :',
        'resolution':'Resolution :',
        'satellite':'Satellite :',
        'orbitalPosition':'Orbital position :',
        'beam':'Beam :',
        'frequency':'Frequency :',
        'polarization':'Polarization :',
        'symbolRate':'Symbol/Rate :',
        'coverage':'COVERAGE',
        'antennaSize':'ANTENNA SIZE',
        'satelliteDetails':'Satellite details',
        'tableOfDbw':'TABLE OF DBW',
        'tableOfDbwAntennaSize':'AND ANTENNA SIZE',
        'satelliteFilter':'SATELLITE FILTER:',
        'contentFilter':'CONTENT FILTER:',
        'channelResolution':'CHANNEL RESOLUTION:',
        'channelEncryption':'CHANNEL ENCRYPTION:',
        'allSatellites':'All satellites',
        'allOrbitalPositions':'All orbital positions',
        'allLanguages':'All languages',
        'allGenres':'All genres',
        'search':'Search',
        'homeTitle1': 'Search for a TV Channel',
        'homeTitle2': 'broadcast via Eutelsat',
        'formRechercheFreeToAir': 'Free-to-air',
        'formRechercheEncoded': 'Encoded',
        'resetListSatellites': 'Refresh lists',
        'tableOfDbwTitleLine1': 'Check the power in dBW with your',
        'tableOfDbwTitleLine2': 'location on the map and cross reference ',
        'tableOfDbwTitleLine3': 'it in the table to find your antenna size.',
        'footerSatellites': 'Satellites',
        'footerReserveCapacity' : 'Reserve capacity',
        'footerPrivacy' : 'Privacy',
        'footerCookiePolicy' : 'Cookie Policy',
        'footerCookieManagement' : 'Cookie Management',
        'footerLegal' : 'Legal',
        'menuButtonContactUs' : 'Contact us'
    }
}